'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _format = require('@marmalade/format');
var _splitField = require('./split-field');
var _splitField2 = _interopRequireDefault(_splitField);
var _input = require('../input');
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Date = function (_Component) {
  _inherits(Date, _Component);
  function Date() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Date);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Date.__proto__ || Object.getPrototypeOf(Date)).call.apply(_ref, [this].concat(args))), _this), _this.handleBlur = function (position, onChange, onBlur) {
      return function (e) {
        var value = e.target.value;
        // Is day or month input - prefix with 0 and submit value
        if (position < _this.inputs().length - 1) {
          if (value.length) {
            onChange(position)((0, _format.prefixZero)(value));
          }
        } else {
          // Is year input - complete year and submit value
          if (value.length) {
            onChange(position)((0, _format.completeYear)(value).toString());
          }
        }
        // this is the important bit to fire validation
        // we tell it the position and the total number of inputs - so it can make decisions on if validation is needed
        onBlur(position);
      };
    }, _this.createInputs = function (values, valid, onChange, onBlur) {
      return _this.inputs().map(function (inputProps, i) {
        return _react2.default.createElement(_input.SmallInput, Object.assign({}, inputProps, {
          value: typeof values[i] !== 'undefined' ? values[i] : '',
          onChange: onChange(i),
          key: i,
          pattern: '[0-9]*',
          format: 'int',
          onBlur: _this.handleBlur(i, onChange, onBlur),
          valid: valid
        }));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Date, [{
    key: 'inputs',
    // props that will be unique across different inputs
    // also provides a handy way of knowing the number of expected inputs to feed back to split field
    value: function inputs() {
      var inputProps = [{
        placeholder: 'DD',
        maxLength: '2',
        name: this.props.name + '_day'
      }, {
        placeholder: 'MM',
        maxLength: '2',
        name: this.props.name + '_month'
      }, {
        placeholder: 'YYYY',
        maxLength: '4',
        name: this.props.name + '_year',
        width: '9rem'
      }];
      if (this.props.noDay) {
        return inputProps.slice(1);
      }
      return inputProps;
    }

    // onBlur should always be fired (it handles validating based on position)
    // handleChange is fired to handle the new values produced from prefixing, etc

    // this function creates an array of inputs based on the input props we set up earlier
    // it will be fired by split field and passed the arguments it needs
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_splitField2.default, {
        name: this.props.name,
        label: this.props.label,
        render: this.createInputs,
        valueCount: this.inputs().length,
        helpText: this.props.helpText,
        disabled: this.props.disabled,
        presetValues: this.props.noDay ? ['01'] : [],
        onBlur: this.props.onBlur
      });
    }
  }]);
  return Date;
}(_react.Component);
Date.propTypes = Object.assign({}, _constants.fieldPropTypes, {
  name: _propTypes.string,
  noDay: _propTypes.bool,
  onBlur: _propTypes.func
});
Date.defaultProps = Object.assign({}, _constants.defaultFieldPropTypes, {
  name: 'date',
  label: 'Please enter a date',
  noDay: false,
  onBlur: undefined
});
exports.default = Date;